// frontend/src/features/citysense/housing-stock-modeller/components/DeprivationPanel.tsx

import React from 'react';
import { DEPRIVATION_LEVELS } from '../constants/housingConfig';

export const DeprivationPanel: React.FC = () => {
  const levels = Object.values(DEPRIVATION_LEVELS).sort((a, b) => a.order - b.order);

  return (
    <div className="bg-gradient-to-br from-blue-50 to-purple-50 border-2 border-blue-200 rounded-xl p-6">
      <h3 className="text-lg font-bold text-gray-800 mb-4">Deprivation Index Legend</h3>
      
      <div className="space-y-3">
        {levels.map((level) => (
          <div key={level.label} className="flex items-center gap-3">
            <div
              className="w-12 h-8 rounded-lg border-2 border-white shadow-md"
              style={{ backgroundColor: level.fill }}
            />
            <span className="text-sm font-semibold text-gray-700">{level.label}</span>
          </div>
        ))}
      </div>

      <div className="mt-6 bg-white rounded-lg p-4">
        <p className="text-xs text-gray-600 leading-relaxed">
          <strong>Color Ramp:</strong> Blue (Very Disadvantaged) → Purple (Very Affluent)
        </p>
        <p className="text-xs text-gray-600 mt-2 leading-relaxed">
          The Deprivation Index indicates the relative prosperity of each area based on census data.
        </p>
      </div>
    </div>
  );
};